import * as Constants from '../Constants';

export interface IPoolStore {
    configuration: any;
}

const defaultState = {
    configuration: {}
};

const pool = (state: IPoolStore = defaultState, action: any) => {
    switch (action.type) {
        case Constants.RESET_POLICY:
            return defaultState;
        case Constants.SET_CONFIGURATION:
            return {
                ...state,
                configuration: action.configuration,
            };
        default:
            return state;
    }
};

export default pool;